module.exports =
  '_ANALYSIS':
    'TITLE': 'スコア分析'
    'UPGRADE':
      'COURSE_STATS': 'コース別分析機能'
      'SCATTER': 'スコア/目標値分布図機能'
      'MESSAGE': 'こちらの機能は有料会員向け機能です。<br/>機能詳細について下記リンクボタンをご覧ください。'
      'UPGRADE_NOW': '機能詳細はこちら'
    'PERIOD_FILTER':
      'ENTIRE_PERIOD': '全期間'
      'LAST_3_MONTHS': '直近3ヶ月'
      'LAST_6_MONTHS': '直近6ヶ月'
      'CUSTOM_RANGE_LABEL': '期間指定'
      'APPLY_LABEL': '適用'
      'CANCEL_LABEL': 'キャンセル'
      'TARGET_RANGE': '対象期間'
      'TARGET_ROUND': '対象ラウンド'
      'INCLUDE_1_5': '1.5ラウンドを含める'
      'EXCLUDE_1_5': '1.5ラウンドを含めない'
      'INCLUDE_0_5': '0.5ラウンドを含める'
      'EXCLUDE_0_5': '0.5ラウンドを含まない'
      'INCLUDE_1_5_SP': '1.5 R を含める'
      'EXCLUDE_1_5_SP': '1.5 R を含めない'
      'INCLUDE_0_5_SP': '0.5 R を含める'
      'EXCLUDE_0_5_SP': '0.5 R を含まない'
    'DETAILED_ANALYSIS':
      'MY_DATA': "マイデータ"
      'GOAL': "目標"
      'MY_AVG': "平均"
      'BEST_SCORE': "ベストスコアラウンド"
      'WORST_SCORE': "ワーストスコアラウンド"
      'ALL_MEMBERS': "会員平均"
      'AVG_TOTAL_SCORE_TITLE': "平均トータルスコア（★１８Ｈ記録済ラウンドのみ対象）"
      'NUMBER_OF_ROUNDS': "ラウンド数合計"
      'AVG_TOTAL_SCORE': "平均トータルスコア"
      'PUTT_TITLE': "パット分析"
      'AVG_PUTT': "ひとホールあたりの平均パット数"
      'RAT_AVG_PUTT': "パーオン時の平均パット数"
      'RAT_FAIRWAY_TITLE': "フェアウェイキープ"
      'FAIRWAY_CENTER': "フェアウェイキープ率 （％）"
      'FAIRWAY_RIGHT': "右ミス （％）"
      'FAIRWAY_LEFT': "左ミス （％）"
      'GIR_ANALYSIS_TITLE': "GIR分析"
      'RAT_PAR_ON': "パーオン率 （％）"
      'RAT_BOGEY_ON': "ボギーオン率 （％）"
      'STROKE_ANALYSIS_TITLE': "ストローク分析"
      'AVG_STROKE_PAR3': "平均ストローク（Par 3）"
      'AVG_STROKE_PAR4': "平均ストローク（Par 4）"
      'AVG_STROKE_PAR5': "平均ストローク（Par 5）"
      'RAT_RECOVERY': "リカバリー率 （％）"
      'SCORE_ANALYSIS_TITLE': "スコア分析"
      'RAT_UNDER_EAGLE': "イーグル以上 （％）"
      'RAT_BIRDIE': "パーディ （％）"
      'RAT_PAR': "パー （％）"
      'RAT_BOGEY': "ボギー （％）"
      'RAT_DBOGEY': "ダブルボギー （％）"
      'RAT_OVER_TBOGEY': "トリプルボギー以上 （％）"
      'SAND_SAVES_TITLE': "ガードバンカー"
      'RAT_SAND_SAVE': "Scrambling from the Sand （％）"
    'SCATTER_CHART':
      'SCORE': 'SCORE'
      'PUTT': 'PUTT'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/i18n/ja.coffee